import menu from './menu'
import scroll from './scroll'
import portfolioScroll from './portfolioScroll'
import workScroll from './workScroll'
import hash from './hash'
import colors from './colors'
import composeReduxMiddlewares from '../../helpers/composeReduxMiddlewares'

export default composeReduxMiddlewares(menu, scroll, portfolioScroll, workScroll, hash, colors)
